module.exports = __webpack_public_path__ + "img/have-noti.73b8ed8f.png";